import { z } from "zod";
import { competenciaSchema, somarMeses } from "./competencia";

/** Meses (inclusive) em que a recorrência gera lançamento, do início até `ate` ou o fim dela. */
export function mesesDaRecorrencia(r: { inicio: string; fim: string | null }, ate: string): string[] {
  const ultimo = r.fim && r.fim < ate ? r.fim : ate;
  const meses: string[] = [];
  for (let m = r.inicio; m <= ultimo && meses.length < 240; m = somarMeses(m, 1)) meses.push(m);
  return meses;
}

/** Dia do vencimento dentro do mês, sem passar do último dia (31 em fevereiro vira 28 ou 29). */
export function vencimentoNoMes(competencia: string, dia: number): string {
  const [a, m] = competencia.split("-").map(Number);
  const ultimoDia = new Date(Date.UTC(a!, m!, 0)).getUTCDate();
  return `${competencia}-${String(Math.min(Math.max(dia, 1), ultimoDia)).padStart(2, "0")}`;
}

export const recorrenciaSalvarSchema = z
  .object({
    id: z.string().min(1).optional(),
    descricao: z.string().trim().min(2, "Descreva o custo").max(200),
    valorCents: z.number().int().positive("Informe o valor"),
    categoriaId: z.string().min(1, "Escolha a categoria"),
    partnerId: z.string().min(1).nullable().optional(),
    diaDoVencimento: z.number().int().min(1).max(31),
    inicio: competenciaSchema,
    fim: competenciaSchema.nullable().optional(),
  })
  .refine((r) => !r.fim || r.fim >= r.inicio, { message: "O último mês vem depois do primeiro", path: ["fim"] });
export type RecorrenciaSalvarInput = z.infer<typeof recorrenciaSalvarSchema>;
